/** @jsxImportSource @emotion/react */
import { useState } from 'react';

import { css, useTheme } from '@emotion/react';
import { Mobile, PC } from 'components/common/Responsive';
import Slider from 'react-slick';
import slide1 from 'static/main/section1_1.png';
import slide2 from 'static/main/section1_2.png';
import slide3 from 'static/main/section1_3.png';
import slideM1 from 'static/main/section1_m1.png';
import slideM2 from 'static/main/section1_m2.png';
import slideM3 from 'static/main/section1_m3.png';

const Section1 = () => {
  const [active, setActive] = useState(0);
  const { mq } = useTheme();

  const section1Style = css`
    background: #f6f1ed;
    padding: 183px 0;
    .container {
      max-width: 1600px;
      padding: 0 40px;
      margin: 0 auto;
      position: relative;
      h2 {
        font-size: 56px;
        line-height: 76px;
        font-weight: 600;
        position: absolute;
        left: 40px;
        top: 40px;
        z-index: 10;
        span {
          font-size: inherit;
          font-weight: inherit;
          transition: 0.3s;
          color: ${active === 0
            ? '#58b139'
            : active === 1
            ? '#FBC53B'
            : '#6079FF'};
        }
        .text {
          font-size: 24px;
          font-weight: 600;
          line-height: 36px;
          margin-top: 8px;
        }
      }
      .slide {
        li {
          margin: 0;
        }
        button {
          &::before {
            content: '';
            padding: 0;
            width: 10px;
            height: 10px;
            background: ${active === 0
              ? '#58b139'
              : active === 1
              ? '#FBC53B'
              : '#6079FF'};
            transition: 0.3s;
            opacity: 0.3;
            border-radius: 50%;
            left: 5px;
            top: 5px;
          }
        }
        .slick-active button {
          &::before {
            opacity: 1;
          }
        }
        img {
          width: 100%;
          max-width: 1232px;
          margin: 0 auto;
        }
      }
    }
    ${mq.mobile} {
      padding: 83px 0px 130px 0px;
      .container {
        padding: 0;
        padding-left: 32px;
        h2 {
          position: static;
          font-size: 28px;
          line-height: 36px;
          .text {
            font-size: 16px;
            line-height: 24px;
          }
        }
        .slide {
          margin-top: 57px;
          .slick-dots {
            bottom: -45px;
          }
          button {
            &::before {
              width: 8px;
              height: 8px;
              left: 6px;
              right: 6px;
            }
          }
        }
      }
    }
  `;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    afterChange: (index: number) => {
      setActive(index);
    },
  };

  return (
    <div css={section1Style}>
      <div className="container">
        <h2>
          <span>좋아하는 상품</span>으로
          <br />내 개성대로 몰 만들기
          <div className="text">상품은 몰파이가 해결해드려요</div>
        </h2>
        <PC>
          <Slider {...settings} className="slide">
            <div>
              <img src={slide1} alt="슬라이드 이미지" />
            </div>
            <div>
              <img src={slide2} alt="슬라이드 이미지" />
            </div>
            <div>
              <img src={slide3} alt="슬라이드 이미지" />
            </div>
          </Slider>
        </PC>
        <Mobile>
          <Slider {...settings} className="slide">
            <div>
              <img src={slideM1} alt="슬라이드 이미지" />
            </div>
            <div>
              <img src={slideM2} alt="슬라이드 이미지" />
            </div>
            <div>
              <img src={slideM3} alt="슬라이드 이미지" />
            </div>
          </Slider>
        </Mobile>
      </div>
    </div>
  );
};

export default Section1;
